export type WidgetAnalyticsConfig = {
  apiBase: string | null;
  /** POST path — default `/api/widget/events`. */
  eventsPath: string;
  /** When false, events are queued in memory and mirrored to GTM only. */
  backendEnabled: boolean;
  /** Console logging (`localStorage.teo_widget_analytics_debug = '1'`). */
  debug: boolean;
  /** Auto-flush N ms after the last queued event (null = only on page hide / greeting). */
  flushDebounceMs: number | null;
};

const STORAGE_KEY = 'teo_widget_analytics_debug';

let config: WidgetAnalyticsConfig = {
  apiBase: null,
  eventsPath: '/api/widget/events',
  backendEnabled: false,
  debug: false,
  flushDebounceMs: null,
};

function readDebugFlag(): boolean {
  if (typeof window === 'undefined') return false;
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored === '1' || stored === 'true';
  } catch {
    return false;
  }
}

export function configureWidgetAnalytics(
  options: Partial<WidgetAnalyticsConfig>,
): void {
  config = {
    ...config,
    ...options,
    debug: options.debug ?? readDebugFlag(),
  };
}

export function getWidgetAnalyticsConfig(): WidgetAnalyticsConfig {
  return {
    ...config,
    debug: config.debug || readDebugFlag(),
  };
}

export function buildWidgetAnalyticsUrl(apiBase: string): string {
  const base = apiBase.replace(/\/$/, '');
  const path = config.eventsPath.startsWith('/')
    ? config.eventsPath
    : `/${config.eventsPath}`;
  return `${base}${path}`;
}
